var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.07,
    d: "M15.737 10.578v.001a.47.47 0 0 1 0 .301v.002a6.996 6.996 0 1 1-8.626-8.62h.001a.52.52 0 0 1 .679.534v.002q0 .06-.02.116v.002a5.941 5.941 0 0 0 7.305 7.314l.15-.028a.53.53 0 0 1 .511.376Z"
  })));
};
export default SvgMoon;